import React from 'react'
import PropTypes from 'prop-types';

export default class Pane extends React.Component {
  static propTypes = {
    left : PropTypes.number,
    right : PropTypes.number,
    bottom : PropTypes.number,
    top : PropTypes.number
  };

  static defaultProps = {
    top : 0, left : 0, right : 0, bottom : 0
  }

  render() {
  
    const { top, left, bottom, right, style, ...rest } = this.props
    return (
      <div style={{ position : 'absolute', overflow : 'auto', top, left, bottom, right, ...style }} {...rest} />
    )
  }
}
